import { render, staticRenderFns } from "./widgets.page.vue?vue&type=template&id=4ff44ee2&"
import script from "./widgets.page.vue?vue&type=script&lang=js&"
export * from "./widgets.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports